<template>
    <b-container>
        <!-- Display success message when "message" is not empty -->
        <div class="alert alert-success" v-if="message">{{ message }}</div>
        <span class="float-right">
            <a href="/admin/risktype/new" class="btn btn-success">Add Risk Type</a>
        </span>
        <h1>Risk Types</h1>
        <b-table striped hover :items="results" :fields="fields">
            <!-- Set Active/Inactive Display -->
            <template #cell(set_active)="data">
                {{ data.item.set_active === 1 ? "Active" : "Inactive" }}
            </template>
            <!-- Edit Button -->
            <template #cell(edit)="data">
                <b-button
                    class="mr-2"
                    variant="primary"
                    @click="$router.push(`/admin/risktype/${data.item.id}/edit`)"
                >
                    Edit
                </b-button>
            </template>
        </b-table>
    </b-container>
</template>

<script>
import PolicyTypeDataService from '@/services/PolicyTypeDataService';

export default {
    name: "risktypeList",
    data() {
        return {
            results: [],
            fields: ['name', 'set_active', 'edit'],
            message: null
        };
    },
    mounted() {
        // Fetch all Risk Types when the component is mounted
        PolicyTypeDataService.getAll().then(response => {
            this.results = response.data;
        }).catch(error => {
            console.error("Error fetching Risk Types:", error);
        });
    },
    created() {
        // Check for an "updated" query parameter and set the success message
        if (this.$route.query.updated === 'success') {            
            this.message = 'Risk Type updated successfully.';
        }      
        
        if (this.$route.query.created === 'success') {            
            this.message = 'Risk Type created successfully.';
        }            
    }
};
</script>
